import { ButtonBase, Stack } from "@mui/material"
import { colors } from "../../../services/config/colors"
import Title from "../common/Title"
import { useContext } from "react"
import {
  defaultBoxShadowDarker,
  desktopColumnsGap,
  desktopMaxWidth,
  desktopPadding,
  navBarHeight,
} from "../../../services/config/constants"
import { useTranslation } from "react-i18next"
import menuWhiteIcon from "../../../assets/icons/menu-white.svg"
import partnerPoweredByAWorldLogo from "../../../assets/images/partner-powered-by-aworld.png"
import { MissionsContext } from "../../../controllers/missions"
import tickets from "../../../assets/icons/tickets.svg"
import { MainContext } from "../../../controllers/main"

const NavBarDesktopTutorial = () => {
  const { t } = useTranslation()
  const { user, isChallengeOver } = useContext(MainContext)
  const { performanceCount } = useContext(MissionsContext)

  return (
    <nav
      role="navigation"
      style={{
        width: "100%",
        height: window.location.pathname === "/" ? 177 : navBarHeight,
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          window.location.pathname === "/"
            ? "rgba(0, 0, 0, 0)"
            : colors.background,
        transition:
          window.location.pathname === "/"
            ? "height 200ms, background-color 200ms"
            : "height 200ms, background-color 0ms",
      }}
    >
      <img
        src={partnerPoweredByAWorldLogo}
        style={{
          height: 49,
          position: "absolute",
          opacity: window.location.pathname === "/" ? 1 : 0,
          transition: "100ms",
          zIndex: 99,
        }}
        alt={t("partner_logo")}
        aria-hidden={window.location.pathname === "/" ? "false" : "true"}
      />
      <Stack
        direction="row"
        alignItems="center"
        style={{
          width: `calc(100% - (${desktopPadding} * 2))`,
          maxWidth: desktopMaxWidth,
          height: 60,
          gap: desktopColumnsGap,
          position: "relative",
        }}
        role="presentation"
      >
        {/* menu */}
        <div
          style={{
            width: 185,
            height: 60,
            borderRadius: 30,
            backgroundColor: colors.backgroundWhite,
            position: "absolute",
            top: 0,
            transition: "250ms",
            transitionTimingFunction: "cubic-bezier(.17, .8, 0.2, 1.15)",
            alignItems: "flex-start",
            boxShadow: defaultBoxShadowDarker,
            zIndex: 99,
          }}
          role="presentation"
        >
          {/* open and close button */}
          <ButtonBase
            disableRipple
            style={{
              width: "100%",
              height: 60,
              position: "absolute",
              justifyContent: "flex-start",
              paddingLeft: 9,
              borderRadius: 30,
              zIndex: 1,
            }}
          >
            <div
              className="center"
              style={{
                width: 46,
                height: 46,
                borderRadius: "100%",
                backgroundColor: colors.primary,
              }}
            >
              <img
                src={menuWhiteIcon}
                style={{
                  width: 26,
                  position: "absolute",
                }}
                alt=""
              />
            </div>
          </ButtonBase>
          {/* current page */}
          <Title
            fontSize={18}
            lineHeight="46px"
            color={colors.primary}
            style={{
              transition: "200ms",
              position: "absolute",
              top: 7,
              left: 67,
            }}
          >
            {t("home")}
          </Title>
        </div>
        {/* performance button */}
        <ButtonBase
          id="navbar-performance-button"
          style={{
            width: 185,
            height: "100%",
            borderRadius: 30,
            backgroundColor: colors.backgroundWhite,
            position: "absolute",
            right: 0,
            boxShadow: defaultBoxShadowDarker,
            zIndex: 99,
          }}
          aria-label={t("performance")}
        >
          <Stack
            direction="row"
            alignItems="center"
            style={{
              width: "100%",
              height: "100%",
              paddingLeft: 9,
            }}
          >
            {isChallengeOver ? (
              <img
                src={user?.profileImage}
                style={{
                  width: 46,
                  height: 46,
                  borderRadius: "100%",
                  position: "relative",
                  zIndex: 1,
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                alt=""
              />
            ) : (
              <div
                style={{
                  width: 46,
                  height: 46,
                  borderRadius: "100%",
                  position: "relative",
                  zIndex: 1,
                  backgroundColor: colors.background,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={tickets} height={24} alt="" />
              </div>
            )}
            <Title
              fontSize={18}
              color={colors.primary}
              style={{
                transition: "400ms",
                position: "absolute",
                zIndex: 1,
                right: 18,
              }}
            >
              {isChallengeOver
                ? `${user?.points} ${t("points")}`
                : t("draw_ticket_short", { x: performanceCount.tickets })}
            </Title>
          </Stack>
        </ButtonBase>
      </Stack>
    </nav>
  )
}

export default NavBarDesktopTutorial
